import Vue from 'vue'
import store from '@/store/index'
import axios from 'axios'
import router from '../router/index'

// 导入nprogresss
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import { Message } from 'element-ui'

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.replace({
    path: '/',
    query: {
      redirect: router.currentRoute.fullPath,
    },
  })
}

// 创建axios实例
var instance = axios.create({ timeout: 1000 * 60 })

//post请求头的设置
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 401:
      toLogin()
      break
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      Message.warning('登录过期，请重新登录!')
      localStorage.removeItem('token')
      store.commit('loginSuccess', null)
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
    // 404请求不存在
    case 404:
      // tip('请求的资源不存在');
      break
    default:
      console.log(other)
  }
}

// 配置响应拦截器
var count = 0;
instance.interceptors.response.use(
  (response) => {
    // 在请求拦截器中隐藏进度条
    NProgress.done()
    // 获取接口返回结果
    const res = response.data
    // code为0，直接把结果返回回去，这样前端代码就不用在获取一次data.
    if (res.code === 0) {
      return res
    } else if (res.code === 401) {
      errorHandle(res.status, res.msg)
      return res
    } else {
      // 错误显示可在service中控制，因为某些场景我们不想要展示错误
      // Message.error(res.message);
      return res
    }
  },
  (aaa) => {
    if (count == 0) Message.warning('网络请求异常，请稍后重试');
    count = 1;
    setTimeout(() => {
      count = 0;
      NProgress.done();
      router.push('/');
    }, 1000);
  }
)

// 配置请求拦截器
instance.interceptors.request.use(
  // 在请求拦截器中显示进度条
  (config) => {
    NProgress.start()
    config.headers.Authorization =
      'Bearer ' + window.localStorage.getItem('token')

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default instance
